
export default function getResource(label, vars = []) {
    const resources = { filterBy: 'Filtrer par' };
    return resources[label];
}
